import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));
